export default {
  storeType: {
    StoreTypeName: '门店类型名称',
    orderDiscount: '折扣',
    remark: '备注',
    createUserId: '创建用户ID',
    createUserName: '创建用户名称',
    createTime: '创建日期',
    modifyUserId: '修改用户ID',
    modifyUserName: '修改用户名称',
    modifyTime: '修改日期',
    addStoreType: '新增门店类型'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/cmc/storeType.js